import { render, staticRenderFns } from "./launch_product_management.vue?vue&type=template&id=31bb2699&"
import script from "./launch_product_management.vue?vue&type=script&lang=js&"
export * from "./launch_product_management.vue?vue&type=script&lang=js&"
import style0 from "./launch_product_management.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports